<template>
  <div class="col-md-12">
    <div class="mb-3">
      <span class="c-toolbar__state-title u-text-capitalize">
        Type: (e.g. choose if a document should be for internal use only.)
      </span>
      <v-select 
        v-model="selectedDocumentType" 
        :options="uxDocumentTypeList" 
        :clearable="false" 
        value="id" 
        label="displayName" 
        id="modal-document-type">
      </v-select>
    </div>

    <div class="file-uploader">
      <div v-if="selectedDocumentType">
        <uploader
          :moduleId="modalStatus.moduleId"
          :actionId="modalStatus.parentActionId"
          @uploadSuccess="onUploadAttachment"
          :id="modalStatus.data.id"
          :document-type-id="selectedDocumentType.id"
          :is-file-share="modalStatus.data && modalStatus.data.category && modalStatus.data.category === 'DocumentTemplate'"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import uploader from "@/components/_universal/uploader/filepond.vue";
  import GlobalServices from "@/services/global";
  import MODULE from "@/constants/modules";
  
  const global = new GlobalServices();

  export default {
    name: "DocumentModal",
    components: {
      uploader,
    },
    data() {
      return {
        attachments: [],
        uxDocumentTypeList: [],
        selectedDocumentType: null,
      };
    },
    computed: {
      // Retrieve modal status from the Vuex store.
      modalStatus() {
        return this.$store.getters.getModalStatus;
      },
    },
    methods: {
      /// <summary>
      /// Handler for the file upload success event.
      /// Adds the uploaded file to the attachments array.
      /// </summary>
      onUploadAttachment(file) {
        this.attachments.push(file);
      },
      /// <summary>
      /// Loads the document type list and sets the default selected type.
      /// If an item with displayName "Internal Use Only" exists, it is set as default.
      /// Otherwise, it falls back to the global default selection.
      /// </summary>
      async loadData() {
        try {
          // Retrieve the document type list
          this.uxDocumentTypeList = await global.getUXDropDown(MODULE.DOCUMENTS.UX.DOCTYPES);
          
          // Search for the document type with displayName "Internal Use Only"
          let defaultType = this.uxDocumentTypeList.find((doc) => doc.displayName === "Internal Use Only");
          
          // If not found, use the fallback default from global services
          if (!defaultType) {
            defaultType = global.setDropDownDefault(this.uxDocumentTypeList);
          }
          
          // Set the selected document type
          this.selectedDocumentType = defaultType;
        } catch (error) {
          //console.error("Error loading document types:", error);
        }
      },
    },
    mounted() {
      this.loadData();
    },
  };
</script>
